var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bierkul-tour.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b30abca0!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bierkul-tour.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/bierkul-tour.vue
// module id = 20
// module chunks = 0